import { game } from "~/js/game";
import { getItem, giveItem, removeItemsFromInventory, renderItem, showSelectItems } from "~/js/items";
import { hashToItemKey, itemKeyToHash } from "~/js/itemsn";
import { createNotification } from "~/js/notifications";
import { getProfile } from "~/js/online/profile";
import { Pages } from "~/js/pages";
import { displayWinnings } from "~/js/winnings";
import { goToPreviousPage, numToValuta, showPage } from "~/script";
import { user } from "~/userStore";

const d = Pages.createPage("coinflip-online");
const y = Pages.createPage("coinflip-online-game");
const b = Pages.createPage("coinflip-online-select");
function w() {
	return new Promise((e) => {
		b.innerHTML = "";
		b.q("h1", "You pick!");
		b.q("p", "You select what coin you want!");
		b.q("p", "Note: If nobody joins your game in 24 hours, it will expire, and you will be returned your items.");
		b.q(".cf-pick-coins", [
			q(".cf-coin-s.cf-coin-s-ct", {
				onclick() {
					e(0);
				},
			}),
			q(".cf-coin-s.cf-coin-s-t", {
				onclick() {
					e(1);
				},
			}),
		]);
		showPage("coinflip-online-select", true);
	});
}
let v = 0;
function x() {
	user.online ??= {};
	user.online.coinflipGames ??= {};
	d.innerHTML = "Loading games...";
	fetch("/api/v16/coinflip.asp?mode=get-games&lu=" + localStorage.localuser)
		.then((e) => e.json())
		.then((e) => {
			if (e.error === "too-many-requests") {
				setTimeout(() => {
					x();
				}, 500);
				return false;
			}
			d.innerHTML = "";
			v++;
			d.q("button.button.back-btn", {
				text: "Back",
				onclick() {
					showPage("betting");
				},
			});
			d.q("h1", "Coinflip Online").q(".h1-beta-flag", "Beta");
			d.q(".cf-about", {
				html: "In Coinflip Online, you can either join a game and roughly match their bet, or create your own game.<br>If you win a coinflip game, you have 2 days to collect your winnings.<br>The odds are in favour of who bets the most, but should always be around ~50%.",
			});
			const i = d.q(".coinflip-controls");
			const c = i.q("button.button", {
				text: "Create Game",
				onclick() {
					showSelectItems(500, undefined, 25).then((e) => {
						let t = 0;
						let n = [];
						e.forEach((e) => {
							n.push(itemKeyToHash[e.name]);
							t += e.price;
						});
						n = n.join(",");
						w().then((o) => {
							fetch(
								"/api/v16/coinflip.asp?mode=create-game&lu=" +
									localStorage.localuser +
									"&n=" +
									encodeURIComponent(getProfile().name) +
									"&ba=" +
									t +
									"&bi=" +
									n +
									"&c=" +
									o,
							)
								.then((e) => e.json())
								.then((t) => {
									if (t.success) {
										removeItemsFromInventory(e.map((e) => e.name));
										j(t.gameid, n);
										k(t.gameid);
									} else {
										console.warn(t);
										alert(t.description);
									}
								});
						});
					});
				},
			});
			i.q("button.button", {
				text: "Refresh",
				onclick() {
					x();
				},
			});
			const r = d.q(".cf-game-section");
			r.q(".cf-game-section-header", "Your Games");
			let l = r.q(".cf-game-section-empty", "You don't have any coinflip games");
			const m = d.q(".cf-game-section");
			m.q(".cf-game-section-header", "Open Games");
			let p = m.q(".cf-game-section-empty", 'There are no public coinflip games, create a new one with "Create Game"');
			let g = 0;
			e.sort((e, t) => e.expireIn - t.expireIn).forEach((e) => {
				try {
					if (e.creator) decodeURIComponent(e.creator);
					if (e.guest) decodeURIComponent(e.guest);
				} catch (t) {
					console.log(t, e);
					return;
				}
				if (parseInt(e.gameid) > g) g = parseInt(e.gameid);
				if (e.state === "FINI" && !user.online.coinflipGames[e.gameid]) return;
				if (e.expireIn - 20 < 0 && !user.online.coinflipGames[e.gameid]) return;
				const n = new Date().getTime() / 1e3;
				const i = q(".cf-game");
				if (e.you === "creator" && e.state === "WAIT") c.disabled = true;
				if (e.you !== "nobody") {
					r.appendChild(i);
					if (l) r.removeChild(l);
					l = false;
				} else if (e.state === "WAIT") {
					m.appendChild(i);
					if (p) m.removeChild(p);
					p = false;
				} else return;
				const s = i.q(".cf-game-info", [
					q(".cf-g-col.cf-g-player", {
						classes: [e.winner !== "0" && (e.winner === "1" ? "cf-g-h-winner" : "cf-g-h-loser"), e.you === "creator" && "cf-g-h-you"],
						children: [
							q(".cf-g-player-s", {
								text: e.winner !== "0" ? (e.winner === "1" ? "Winner" : "Loser") : "",
							}),
							q(".cf-g-player-p", {
								text: !e.creator ? "?" : e.you === "creator" ? "You" : decodeURIComponent(e.creator),
							}),
							q(".cf-g-coin.cf-g-coin-c", {
								classes: [e.choice === "CT" ? "cf-g-coin-ct" : "cf-g-coin-t"],
							}),
							q(".cf-g-player-p-a", { text: numToValuta(e.creator_bet, 2) }),
						],
					}),
					q(".cf-g-col.cf-g-vs", { text: "vs." }),
					q(".cf-g-col.cf-g-player", {
						classes: [
							e.winner !== "0" && (e.winner === "2" ? "cf-g-h-winner" : "cf-g-h-loser"),
							!e.guest && "cf-g-joinable",
							e.you === "guest" && "cf-g-h-you",
						],
						children: [
							q(".cf-g-player-s", {
								text: e.winner !== "0" ? (e.winner === "2" ? "Winner" : "Loser") : "",
							}),
							q(".cf-g-player-p", {
								text: !e.guest ? "?" : e.you === "guest" ? "You" : decodeURIComponent(e.guest),
							}),
							q(".cf-g-coin.cf-g-coin-c", {
								classes: [e.choice !== "CT" ? "cf-g-coin-ct" : "cf-g-coin-t"],
							}),
							q(".cf-g-player-p-a", {
								text: e.guest_bet ? numToValuta(e.guest_bet, 2) : "",
							}),
						],
					}),
				]);
				const a = i.q({ style: { display: "flex", justifyContent: "center" } });
				a.q(".cf-game-btns").q("button.button", {
					text: e.winner !== "0" && e.winner === I[e.you] ? "Collect Your Winnings" : "See",
					onclick() {
						k(e.gameid);
					},
				});
				if (e.state === "FINI" && e.winner !== I[e.you]) {
					const t = a.q(".cf-game-btns").q("button.button", {
						text: "Dismiss this game",
						onclick() {
							G(e.gameid);
						},
					});
					let o = v;
					const i = setInterval(() => {
						t.innerText = "Dismissing in " + Y(Math.floor(e.expireIn - (new Date().getTime() / 1e3 - n)));
						if (v !== o) clearInterval(i);
					}, 1e3);
				}
				if (!e.guest) i.q(".cf-g-joinable-text", { text: "Looking for contestant" });
				setTimeout(
					() => {
						if (i.parentElement) i.parentElement.removeChild(i);
					},
					(e.expireIn - (e.you === "creator" || user.online.coinflipGames[e.gameid] ? 1 : 120)) * 1e3,
				);
			});
			if (g > 0)
				d.q(".cf-games-total", {
					text: g + " coinflips games have been created!",
				});
		});
	C();
}
function C() {
	user.online ??= {};
	user.online.coinflipGames ??= {};
	for (let e = 0; e < Object.keys(user.online.coinflipGames).length; e++) {
		let t = Object.keys(user.online.coinflipGames)[e];
		fetch("/api/v16/coinflip.asp?mode=get-game&gameid=" + t + "&lu=" + localStorage.localuser)
			.then((e) => e.json())
			.then((e) => {
				if (!e.success && e.error === "game-not-found") M(t);
				else if (e.state === "FINI" && e.you === "creator" && !user.online.coinflipGames[t].msg) {
					user.online.coinflipGames[t].msg = true;
					user.online.coinflipGames[t].lost = e.winner !== I[e.you];
					createNotification({
						message: "A coinflip game has been finished. <a>Click here to see if you have won!</a>",
						useHtml: true,
						onclick() {
							k(t);
						},
					});
				}
			});
	}
}
setTimeout(() => {
	C();
}, 1e4);
setInterval(() => {
	C();
}, 12e4);
let T = 0;
function k(o, c, m) {
	T++;
	showPage("coinflip-online-game", c, true);
	if (!m) y.innerHTML = "Loading game...";
	fetch("/api/v16/coinflip.asp?mode=get-game&gameid=" + o + "&lu=" + localStorage.localuser)
		.then((e) => e.json())
		.then((n) => {
			let c = T;
			if (!n.success) {
				y.innerHTML = "";
				y.q(".cf-gi-title", { text: "Coinflip Game Removed | Not found" });
				y.q({
					text: "This game doesn't exist anymore. Either because it has expired, or 2 days have gone since it was finished.",
					style: { textAlign: "center" },
				});
				y.q("button.button.back-btn", {
					text: "Go back",
					onclick() {
						goToPreviousPage();
					},
				});
				return;
			}
			setTimeout(() => {
				if (c === T && n.state === "WAIT") {
					m = n.state;
					k(o, true, n.state);
				}
			}, 1e4);
			if (m && n.state === m) {
				m = false;
				return;
			}
			y.innerHTML = "";
			y.q(".cf-gi-title", {
				text: decodeURIComponent(n.creator) + " vs. " + (decodeURIComponent(n.guest) || "?"),
			});
			y.q("button.button.back-btn", {
				text: "Back",
				onclick() {
					goToPreviousPage();
				},
			});
			const p = y.q(".cf-coin-area.hide");
			const g = y.q(".center");
			const h = y.q(".cf-gi-players");
			const d = h.q(".cf-gi-player");
			d.q(".center").q("img", {
				src: "/images/coin_" + n.choice.toLowerCase() + ".png",
				height: 32,
			});
			let b = 0,
				q = 0;
			const w = d.q(".cf-gi-player-bet");
			const v = d.q(".cf-gi-player-inventory.compact");
			n.creator_items
				.split(",")
				.splice(0, 25)
				.forEach((e) => {
					if (e === "") return;
					e = getItem(hashToItemKey[e]);
					b += e.price;
					v.appendChild(renderItem(e));
				});
			w.innerText = (n.you === "creator" ? "Your" : decodeURIComponent(n.creator) + "'s") + " bet: " + numToValuta(b, 2);
			let x = false;
			if (n.creator_bet * 1.01 < b || n.creator_bet * 0.99 > b) x = true;
			const C = h.q(".cf-gi-player");
			C.q(".center").q("img.cf-img", {
				src: "/images/coin_" + (n.choice === "CT" ? "T" : "CT").toLowerCase() + ".png",
				height: 32,
			});
			let M = C.q(".cf-gi-player-bet", "Join!");
			const Y = C.q(".cf-gi-player-inventory.compact");
			if (n.guest_items) {
				n.guest_items
					.split(",")
					.splice(0, 25)
					.forEach((e) => {
						if (e === "") return;
						e = getItem(hashToItemKey[e]);
						q += e.price;
						Y.appendChild(renderItem(e));
					});
				M.innerText = (n.you === "guest" ? "Your" : decodeURIComponent(n.guest) + "'s") + " bet: " + numToValuta(q, 2);
			} else {
				Y.q("button.button", {
					text: x ? "Due to skin price differences, this game is unavailable for you." : "Join this coinflip!",
					disabled: x || n.you !== "nobody",
					onclick() {
						if (n.you !== "nobody") return;
						showSelectItems(n.creator_bet * 0.9, n.creator_bet * 1.1, 25).then((e) => {
							let t = 0;
							let n = [];
							e.forEach((e) => {
								n.push(itemKeyToHash[e.name]);
								t += e.price;
							});
							n = n.join(",");
							fetch(
								"/api/v16/coinflip.asp?mode=join-game&gameid=" +
									o +
									"&lu=" +
									localStorage.localuser +
									"&n=" +
									encodeURIComponent(getProfile().name) +
									"&bi=" +
									n +
									"&ba=" +
									t,
							)
								.then((e) => e.json())
								.then((t) => {
									if (t.success) {
										removeItemsFromInventory(e.map((e) => e.name));
										j(o, n);
										k(o, true);
									} else {
										console.warn(t);
										alert(t.description);
									}
								});
						});
					},
				});
			}
			if (n.winner === "0") {
			} else if (n.you === "nobody") {
				let e = n.choice === "CT" ? 0 : 1;
				if (n.winner === "2") e = e === 0 ? 1 : 0;
				p.classList.remove("hide");
				const t = p.q(".coinflip-perspective").q("#coinflip-coin");
				t.q(".coinflip-face-ct");
				t.q(".coinflip-face-t");
				setTimeout(() => {
					if (T !== c) return;
					t.style.transition = "4s";
					t.style.transform = `rotateY(${180 * Math.ceil(8 + e)}deg)`;
				}, 100);
			} else if (n.winner === I[n.you]) {
				let e = n.choice === "CT" ? 0 : 1;
				if (n.you === "guest") e = e === 0 ? 1 : 0;
				p.classList.remove("hide");
				const t = p.q(".coinflip-perspective").q("#coinflip-coin");
				t.q(".coinflip-face-ct");
				t.q(".coinflip-face-t");
				setTimeout(() => {
					if (T !== c) return;
					t.style.transition = "4s";
					t.style.transform = `rotateY(${180 * Math.ceil(8 + e)}deg)`;
				}, 100);
				setTimeout(() => {
					if (T !== c) return;
					g.q(".cf-gi-ws", "You won!");
					g.q("button.button", {
						text: "Collect your winnings",
						onclick() {
							L(n.gameid, n.creator_items, n.guest_items, n.creator_bet, n.guest_bet);
						},
					});
				}, 4100);
			} else {
				let e = n.choice === "CT" ? 1 : 0;
				if (n.you === "guest") e = e === 0 ? 1 : 0;
				p.classList.remove("hide");
				const t = p.q(".coinflip-perspective").q("#coinflip-coin");
				t.q(".coinflip-face-ct");
				t.q(".coinflip-face-t");
				setTimeout(() => {
					if (T !== c) return;
					t.style.transition = "4s";
					t.style.transform = `rotateY(${180 * Math.ceil(8 + e)}deg)`;
				}, 100);
				setTimeout(() => {
					if (T !== c) return;
					g.q(".cf-gi-ws", "You lost...");
					g.q("button.button", {
						text: "Dismiss the game",
						onclick() {
							G(n.gameid);
						},
					});
				}, 4100);
			}
		});
}
game.on("showPage", (e) => e.page === "coinflip-online" && x());
let I = { nobody: "0", creator: "1", guest: "2" };
function j(e, t) {
	user.online.coinflipGames[e] = { g: true, i: t };
}
function G(e) {
	delete user.online.coinflipGames[e];
	showPage("coinflip-online");
}
function L(e, t, n, s, r) {
	if (!user.online.coinflipGames[e]) return;
	delete user.online.coinflipGames[e];
	let a = [];
	let f = 0,
		u = 0;
	t.split(",")
		.map((e) => hashToItemKey[e])
		.forEach((e) => {
			f += getItem(e).price;
			if (f > s * 1.01) return;
			a.push(getItem(e));
			giveItem(e);
		});
	n.split(",")
		.map((e) => hashToItemKey[e])
		.forEach((e) => {
			u += getItem(e).price;
			if (u > r * 1.01) return;
			a.push(getItem(e));
			giveItem(e);
		});
	displayWinnings({
		title: "Your winnings!",
		returnBtn: { text: "Go back!", page: "coinflip-online" },
		items: a,
		sortBy: "value",
	});
}
game.on("showPage", (e) => {
	if (e !== "coinflip-online-game") T++;
});
function M(e) {
	if (!user.online.coinflipGames[e].i || user.online.coinflipGames[e].lost) {
		delete user.online.coinflipGames[e];
		return;
	}
	user.online.coinflipGames[e].i
		.split(",")
		.map((e) => hashToItemKey[e])
		.forEach((e) => {
			giveItem(e);
		});
	delete user.online.coinflipGames[e];
	createNotification({
		message: "Your coinflip game timeouted, your items have been returned.",
	});
}
function Y(e) {
	if (e < 60) return e + " second" + (e === 1 ? "" : "s");
	if (e < 60 * 60) return Math.floor(e / 60) + " minute" + (Math.floor(e / 60) === 1 ? "" : "s");
	if (e < 60 * 60 * 24) return Math.floor(e / 60 / 60) + " hour" + (Math.floor(e / 60 / 60) === 1 ? "" : "s");
	else return Math.floor(e / 60 / 60 / 24) + " day" + (Math.floor(e / 60 / 60 / 24) === 1 ? "" : "s");
}
